import {
  GetHiringStagesDocument,
  UpdateAtsHiringPhaseDocument,
  UpdateAtsHiringPhaseMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateAtsHiringPhase = () => {
  const [updateAtsHiringPhase, { loading }] = useMutation(UpdateAtsHiringPhaseDocument, {
    extractorFn: (data: UpdateAtsHiringPhaseMutation) => data.atsMutations.updateAtsHiringPhase,
  })

  return {
    loading,
    updateAtsHiringPhase(id: number, name: string, atsHiringStageId: number) {
      return updateAtsHiringPhase({
        variables: { id, name, atsHiringStageId },
        refetchQueries: [GetHiringStagesDocument],
      })
    },
  }
}
